module.exports = __webpack_public_path__ + "static/media/Panosta-white-background.7693af8d.svg";